import { useSearchParams } from 'react-router-dom';

const API_URL = import.meta.env.VITE_API_URL ?? '/api';

const ERROR_MESSAGES: Record<string, string> = {
  unauthorized: 'This Google account is not authorized. Ask an administrator to add you.',
};

export default function Login() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const errorMsg = error ? ERROR_MESSAGES[error] ?? 'Sign-in failed. Please try again.' : null;

  const signIn = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  return (
    <div
      className="theme-noc"
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(1100px 600px at 50% -10%, rgba(0,229,255,0.08), transparent 60%), var(--surface-app)',
        color: 'var(--text-primary)',
      }}
    >
      <div
        style={{
          width: 380,
          background: 'var(--surface-raised)',
          border: '1px solid var(--border)',
          borderRadius: 16,
          padding: 36,
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
        }}
      >
        {/* brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 26 }}>
          <img src="/flycommc2-logo.svg" alt="FlycommC2" style={{ height: 64, width: 'auto' }} />
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
            <span
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 600,
                fontSize: 22,
                letterSpacing: 0.5,
              }}
            >
              FlycommC2
            </span>
            <span
              className="eyebrow"
              style={{
                fontSize: 11,
                letterSpacing: 1.3,
                color: 'var(--text-dim)',
              }}
            >
              Spectrum Dominance Through Intelligence
            </span>
          </div>
        </div>

        <h1 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 6px' }}>Sign in to continue</h1>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '0 0 24px', lineHeight: 1.5 }}>
          Access is by invitation. Sign in with the Google account your administrator authorized.
        </p>

        {errorMsg && (
          <div
            role="alert"
            style={{
              background: 'rgba(255,77,77,0.12)',
              border: '1px solid #ff4d4d',
              borderRadius: 9,
              color: 'var(--text-primary)',
              fontSize: 13,
              padding: '10px 12px',
              marginBottom: 18,
            }}
          >
            {errorMsg}
          </div>
        )}

        <button
          type="button"
          onClick={signIn}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            background: '#ffffff',
            color: '#1f2328',
            border: 'none',
            borderRadius: 10,
            fontSize: 14,
            fontWeight: 600,
            padding: '12px 18px',
            cursor: 'pointer',
          }}
        >
          <GoogleG />
          Continue with Google
        </button>

        <p
          style={{
            fontSize: 12,
            color: 'var(--text-dim)',
            margin: '22px 0 0',
            textAlign: 'center',
            lineHeight: 1.5,
          }}
        >
          By signing in you agree to operate within your organization's authorized scope.
        </p>
      </div>
    </div>
  );
}

/** Google "G" mark. */
function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
      />
      <path
        fill="#34A853"
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"
      />
      <path
        fill="#FBBC05"
        d="M3.97 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"
      />
      <path
        fill="#EA4335"
        d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"
      />
    </svg>
  );
}
